import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { Button, Card, ListGroup, Badge, Table, Image } from 'react-bootstrap'
import { Link, useNavigate } from 'react-router-dom'
import { styles } from '../layout/styles'
import { getStorage, ref, getDownloadURL, listAll } from "firebase/storage";
import { grey } from '../../config/Colors';

const EntitySummary = (entity) => {
    //console.log(entity);
    const navigate = useNavigate();

    const wellness = entity.wellness;
    const ownwellness = wellness.filter((wellnessRecord) => entity.entity.id === wellnessRecord.entityid);
    //console.log(ownwellness);
    const pgender = entity && entity.entity.gender == 'M' ? 'Male' : 'Female';
    const pimage = pgender && pgender == 'Male' ? '/images/boyProfile2.png' : '/images/girlProfile2.png';
    let profileimageurl = (entity?.entity?.profileimageurl) ? entity?.entity?.profileimageurl : (process.env.PUBLIC_URL + pimage);

    const [imageList, setimageList] = useState([]);

    // useEffect(() => {
    //     setimageList([]);
    //     const reportURL = entity.entity.entitybyuser + "/" + entity.entity.id + "/";
    //     //console.log(reportURL);
    //     const storage = getStorage();
    //     const storageRef = ref(storage, reportURL);      
    //     // Find all the prefixes and items.
    //     listAll(storageRef)
    //     .then((res) => {
    //         setimageList([]);
    //         res.items.forEach((itemRef) => {
    //             const reportPath = itemRef._location.path_;
    //             const pdfFileName = reportPath.replace(/^.*[\\\/]/, '').replace('.pdf', '');
    //             let pDate = new Intl.DateTimeFormat("en-US", {
    //                 year: "numeric",
    //                 month: "2-digit",
    //                 day: "2-digit",
    //                 hour: "2-digit",
    //                 minute: "2-digit",
    //                 second: "2-digit",
    //               }).format(pdfFileName);
    //             // All the items under listRef.
    //             getDownloadURL(itemRef).then((url) => {
    //                 const pdfItem = {
    //                     Name:'Wellness Report - ' + pDate, 
    //                     URL:url
    //                 }
    //                 setimageList((prev) => [...prev, pdfItem]);
    //                 //console.log(pdfItem);
    //             });
    //         });
    //     }).catch((error) => {
    //         console.log('Error in listall storage.');
    //     }); 
    // }, []);

    return ( 
        // <div className='card' style={{ display:'flex', flexDirection:"row", padding: "10px 10px", width: '95%', height:'240px', textAlign:"center"}}>
        //     <div className="text-center mt-5" style={{ flex:'1', width:'80px', margin:"auto"}}>          
        //         <Card.Img style={{ width: '80px', height:'60px', alignItem:'center', justifyContent: "center", }} src={process.env.PUBLIC_URL + pimage} />
        //     </div>            
        //     <div className='card-content' style={{ flex:'2', width:'300px', margin:"auto"}}>
        //         <span className='card-title'>{entity.entity.firstname} {entity.entity.lastname}</span>
        //         <p>Gender: {pgender}</p>
        //         <p>Date of birth: {entity.entity.dateofbirth && entity.entity.dateofbirth.toDate().toDateString()}</p>                
        //         <p>
        //             <Link style={styles.SubLink} to={'/entitydetails/' + entity.entity.id}>View</Link>{' '}&nbsp;&nbsp;
        //             <Link style={styles.SubLink} to={'/updateentity/' + entity.entity.id}>Edit</Link>
        //         </p>
        //         <div>
        //             {imageList.map((pdfItem) => {
        //                 console.log(pdfItem);
        //                 return <p><Link target="_blank" style={styles.SubLink} to={pdfItem.URL}>{pdfItem.Name}</Link></p>
        //             })}
        //         </div>
        //     </div>
        //     <div className="w-60 text-bottom, mt-5"  style={{ width:'120px', textAlign:'right', verticalAlign:'center', margin:"auto"}}>                    
        //         <Link style={styles.SubLink} to={'/initiatewellness/' + entity.entity.id}>Start wellness program</Link>
        //     </div>            
        // </div>

<div>
<Card className="text-center">
<Card.Header> 
    <Table responsive="lg" >
            <thead>
            <tr>
                <th style={{width:'25%', alignItems:'left'}}>
                    <Card.Img style={{ width: '120px', height:'80px', alignItem:'left', justifyContent: "left", alignSelf:"left"}} src={profileimageurl} />
                </th>
                <th>
                    <Card.Title>
                        <h4>{entity.entity.firstname} {entity.entity.lastname}</h4>                        
                    </Card.Title>
                </th>
                <th style={{width:'25%', alignItems:'center'}}>
                  <Card.Text style={{color:grey}}>
                    <span>
                    Gender: {pgender}<br/>
                    Date of birth: {entity.entity.dateofbirth && entity.entity.dateofbirth.toDate().toDateString()}<br/>
                    Height: {entity.entity.height} &nbsp;&nbsp; Weight: {entity.entity.weight}
                    </span>
                    </Card.Text>
                </th>
                <th style={{width:'5%', alignItems:'right', color:grey}}>
                    <Link style={styles.SubLink} to={'/updateentity/' + entity.entity.id}><span class="material-symbols-outlined" style={{color:grey}}>
                        Edit
                    </span></Link>
                </th>
            </tr>
            </thead>
            <tbody>
            </tbody>
    </Table>

</Card.Header>
<Card.Body>
   {(ownwellness.length === 0) ? (
            <div style={styles.tableText}>
                No previous wellness reports. Please start the first wellness program.
            </div>
        ) : (
            <div>
                <Table responsive="sm" striped bordered hover variant="light">
                    <thead>
                    <tr>
                        <th style={styles.tableText}>#</th>
                        <th style={styles.tableText}>Date</th>
                        <th style={styles.tableText}>Growth</th>
                        <th style={styles.tableText}>Development</th>
                        <th style={styles.tableText}>Nutritional</th>
                        <th style={styles.tableText}>Social</th>
                        <th style={styles.tableText}>Emotional</th>
                        <th style={styles.tableText}>Oral</th>
                        <th style={styles.tableText}>Vaccinations</th>
                        <th style={styles.tableText}>Overall</th>
                        <th style={styles.tableText}>Report</th>
                    </tr>
                    </thead>
                    <tbody>
                    {ownwellness && ownwellness.map((wellnessRecord, index) => {
                        if (entity.entity.id === wellnessRecord.entityid) {
                            return (
                                <tr>
                                    <td style={styles.tableText}>{index + 1}</td>
                                    <td style={styles.tableText}>{wellnessRecord.createddate.toDate().toDateString()} {wellnessRecord.createddate.toDate().toLocaleTimeString('en-US', { hour: 'numeric', minute: 'numeric' })}</td>
                                    <td style={{textAlign:'center'}}><Image style={styles.Image25} src={process.env.PUBLIC_URL + "/images/GreenFace.png"} roundedCircle /></td>
                                    <td style={{textAlign:'center'}}><Image style={styles.Image25} src={process.env.PUBLIC_URL + "/images/RedCryFace.png"} roundedCircle /></td>
                                    <td style={{textAlign:'center'}}><Image style={styles.Image25} src={process.env.PUBLIC_URL + "/images/OrangeFace2.png"} roundedCircle /></td>
                                    <td style={{textAlign:'center'}}><Image style={styles.Image25} src={process.env.PUBLIC_URL + "/images/GreenFace.png"} roundedCircle /></td>
                                    <td style={{textAlign:'center'}}><Image style={styles.Image25} src={process.env.PUBLIC_URL + "/images/OrangeFace2.png"} roundedCircle /></td>
                                    <td style={{textAlign:'center'}}><Image style={styles.Image25} src={process.env.PUBLIC_URL + "/images/RedCryFace.png"} roundedCircle /></td>
                                    <td style={{textAlign:'center'}}><Image style={styles.Image25} src={process.env.PUBLIC_URL + "/images/GreenFace.png"} roundedCircle /></td>
                                    <td style={{textAlign:'center'}}><Image style={styles.Image25} src={process.env.PUBLIC_URL + "/images/OrangeFace2.png"} roundedCircle /></td>
                                    <td style={styles.tableText}>      
                                        <a target="_blank" href={wellnessRecord.wellnessreportlocation}>
                                            <span class="material-symbols-outlined" style={{color:grey, fontSize:'25px'}}>monitoring</span>
                                            {/* <Button size="sm" style={styles.CDPillFullButton}>
                                                View
                                            </Button>           */}
                                        </a>
                                    </td>
                                </tr>
                            )
                        }
                    }
                    ) 
                    }    

                    </tbody>
                </Table>        
           </div>
        )}

    <div>
    </div>

</Card.Body>
<Card.Footer className="text-right" style={{alignItems:'end'}}>
    <div>
        <Button size="sm" variant="primary" style={styles.CDButton20} onClick={() => navigate('/initiatewellness/' + entity.entity.id)}>
            Wellness Program
            {/* <Link style={styles.SubLink} to={'/initiatewellness/' + entity.entity.id}></Link> */}
        </Button>
    </div>
</Card.Footer>
</Card>
</div>
    )        
}

const mapStateToProps = (state, ownProps) => {
    const ownentities = state.firestore.ordered.entities ? state.firestore.ordered.entities : state.entity.entities;
    return {
      entities: ownentities,
      auth: state.firebase.auth
    }
}

export default connect(mapStateToProps, null)(EntitySummary)
